var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_167448",
    "data-name": "Group 167448",
    transform: "translate(440 -271) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3232",
    "data-name": "Path 3232",
    d: "M1164,1235.48l7,7,7-7",
    transform: "translate(-955.98 1599) rotate(-90)",
    fill: "none",
    stroke: "#636974",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownIcon);
export default __webpack_public_path__ + "static/media/arrowDown_icon.e27d9d8b59818186371bbbeeaa9463f6.svg";
export { ForwardRef as ReactComponent };